/*import { axiosAPI, responseHandler } from 'utils';

export default {
  getPrepaidStatus: (familyId) =>
    responseHandler(axiosAPI.get(`api/families/prepaid-status/${familyId}`)),
  trackPlayTimeForPrepaidPlan: (familyId, timeInMinutes) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/add-play-time`, {
        timeInMinutes,
      })
    ),
    editPrepaidStatus: (familyId, paymentQty = 1, purchaseProduct = false, subscription = null, automaticPayments = false) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/edit-prepaid-status`, {
        paymentQty, purchaseProduct, subscription, automaticPayments
      })
    ),
    removePaymentMethod: (familyId) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/remove-payment-method`)
    ),
};
*/
/*
import { axiosAPI, responseHandler } from 'utils';

export default {
  getPrepaidStatus: (familyId) =>
    responseHandler(axiosAPI.get(`api/families/prepaid-status/${familyId}`)),
  trackPlayTimeForPrepaidPlan: (familyId, timeInMinutes) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/add-play-time`, {
        timeInMinutes,
      })
    ),
  editPrepaidStatus: (familyId, paymentQty = 1, purchaseProduct = false, subscription = null, automaticPayments = false) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/edit-prepaid-status`, {
        paymentQty, purchaseProduct, subscription, automaticPayments
      })
    ),
  removePaymentMethod: (familyId) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/remove-payment-method`)
    ),
  getAdditionalProductsStatus: (familyId) =>
    responseHandler(
      axiosAPI.get(`api/families/prepaid-status/${familyId}/additional-products-status`)
    ),
};
*/
/*
import { axiosAPI, responseHandler } from 'utils';

export default {
  getPrepaidStatus: (familyId) =>
    responseHandler(axiosAPI.get(`api/families/prepaid-status/${familyId}`)),
  trackPlayTimeForPrepaidPlan: (familyId, timeInMinutes) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/add-play-time`, {
        timeInMinutes,
      })
    ),
  editPrepaidStatus: (familyId, paymentQty = 1, purchaseProduct = false, subscription = null, automaticPayments = false) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/edit-prepaid-status`, {
        paymentQty, purchaseProduct, subscription, automaticPayments
      })
    ),
  removePaymentMethod: (familyId) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/remove-payment-method`)
    ),
  getAdditionalProductsStatus: (familyId) =>
    responseHandler(
      axiosAPI.get(`api/families/prepaid-status/${familyId}/additional-products-status`)
    ),
};
*/
import { axiosAPI, responseHandler } from 'utils';

export default {
  getPrepaidStatus: (familyId) =>
    responseHandler(axiosAPI.get(`api/families/prepaid-status/${familyId}`)),
  getAdditionalProductsStatus: (familyId) =>
    responseHandler(axiosAPI.get(`api/families/prepaid-status/${familyId}/additional-products-status`)),
  trackPlayTimeForPrepaidPlan: (familyId, timeInMinutes) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/add-play-time`, {
        timeInMinutes,
      })
    ),
    editPrepaidStatus: (familyId, paymentQty = 1, purchaseProduct = false, subscription = null, automaticPayments = false) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/edit-prepaid-status`, {
        paymentQty, purchaseProduct, subscription, automaticPayments
      })
    ),
    removePaymentMethod: (familyId) =>
    responseHandler(
      axiosAPI.post(`api/families/prepaid-status/${familyId}/remove-payment-method`)
    ),
};
